function r(r){for(var n=[];Array.isArray(r);)n.push(r.length),r=r[0];return n}export{r as arrayDims};
